<template lang="pug">
    section(style="height:44px")
        div.tradingview-widget-container(v-if="tape")
            div.tradingview-widget-container__widget
                component(is="script" src="https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js" async) {{ tape_data }}
</template>

<script>
    export default {
        name: "DealsWidget",
        computed: {
            userPortfolio () {
                return this.$store.state.client.userPortfolio
            },
            userPortfolioLoaded: {
                get: function() {
                    return this.$store.state.client.userPortfolioLoaded
                },
            }
        },
        watch: {
            userPortfolioLoaded (newValue) {
                if (newValue) {
                    this.addTickersToWidgetOptions()
                }
            }
        },
        data () {
            return {
                tape: false,
                tape_test: 'none',
                tape_data: {
                    "symbols": [
                        {
                            "proName": "OANDA:NAS100USD",
                            "title": "NASDAQ 100"
                        },
                        {
                            "description": "DOW",
                            "proName": "FOREXCOM:DJI"
                        }
                    ],
                    "colorTheme": "light",
                    "isTransparent": true,
                    "displayMode": "true",
                    "locale":"ru"
                }
            }
        },
        methods: {
            addTickersToWidgetOptions () {
                let symbols_array = this.preparePortfolioArray()
                for (let s in symbols_array){
                    this.tape_data.symbols.push({
                        "description":symbols_array[s].symbol,
                        "proName": `${symbols_array[s].instrument}:${symbols_array[s].symbol}`
                    })
                }
                this.tape = true
            },
            preparePortfolioArray () {
                let tickersArray = this.userPortfolio.map(function(item) {
                    return {'symbol':item.symbol.symbol, 'instrument': item.symbol.ticker_type}
                })
                return tickersArray
            }
        },
        mounted () {
            if (this.userPortfolioLoaded) {
                this.addTickersToWidgetOptions()
            }
        }
    }
</script>

<style scoped>

</style>
